import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { routes } from './routes';
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { useAtom, useAtomValue } from 'jotai';
import { userAtom, globalAtom } from './store/atom';
import { useEffect } from 'react';
import { getUserDetails } from './services/userServices';
import { USER_ROLES } from './types';
import { getTokenHeaderFromMsal } from './helper/config';
import { loginRequest } from './main';
import SessionErrorBoundary from './components/SessionErrorBoundary';

const App = () => {
  const { userRole } = useAtomValue(globalAtom);
  const { accounts } = useMsal();
  const [globalState, setGlobalState] = useAtom(globalAtom);
  const [userState, setUserState] = useAtom(userAtom);

  const getUser = async () => {
    const { data, error } = await getUserDetails();
    if (error) {
      return setUserState({
        ...userState,
        error: true,
      });
    }
    if (data) {
      setGlobalState({
        ...globalState,
        loggedIn: true,
        userRole: {
          isHR:
            data?.userRoles?.findIndex((i) => i.role.name === USER_ROLES.HR) !==
            -1
              ? true
              : false,
          isMentor:
            data?.userRoles?.findIndex(
              (i) => i.role.name === USER_ROLES.MENTOR
            ) !== -1
              ? true
              : false,
        },
        userInfo: {
          id: data.id,
          mentor: data?.mentor,
          tier: data.tier,
          designation: data.designation,
        },
      });
    }
  };

  const getToken = async () => {
    const token: string = await getTokenHeaderFromMsal();
    return token;
  };

  useEffect(() => {
    if (accounts[0]) {
      const storage = localStorage.getItem('atomStore')
        ? JSON.parse(localStorage.getItem('atomStore') || '')
        : undefined;
      if (!storage?.loggedIn) {
        getToken().then(() => {
          getUser();
        });
      }
    }
  }, [accounts]);

  return (
    <SessionErrorBoundary>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
      >
        <RouterProvider router={createBrowserRouter(routes(userRole))} />
      </MsalAuthenticationTemplate>
    </SessionErrorBoundary>
  );
};

export default App;
